<template>
	<div class="text-center">
		<v-container>
			<div :class="['text-h6', 'pa-2']">
				{{ $t('titles.item') }}
			</div>
			<v-row dense>
				<v-col cols="12">
					<Dropdown2
						v-model="paymentContractItem.payment_contract_item_type_id"
						:ajax="true"
						:data="'payment-contract-item-types'"
						:errorBorder="!paymentContractItemValidation.payment_contract_item_type_id"
						:label="'* ' + $t('fields.type')"
						@item-selected="getItemTax"
					></Dropdown2>
				</v-col>
				<v-col cols="12" v-if="paymentContractItem.payment_contract_item_type_id == 1">
					<Dropdown2
						v-model="paymentContractItem.course_id"
						:ajax="true"
						:data="'courses'"
						:errorBorder="!paymentContractItemValidation.course_id"
						:label="'* ' + $t('fields.course')"
						@item-selected="handleCourseSelected"
					></Dropdown2>
				</v-col>
				<v-col cols="12" style="display: flex; align-items: center">
					<CheckBox
						:disabled="!vatExists"
						v-model="paymentContractItem.vat_exists"
						:label="$t('fields.vat2')"
					></CheckBox>
				</v-col>
				<v-col cols="12">
					<NumberField
						v-model="paymentContractItem.quantity"
						:errorBorder="!paymentContractItemValidation.quantity"
						:label="'* ' + $t('fields.quantity')"
					></NumberField>
				</v-col>
				<v-col cols="12">
					<NumberField
						:disabled="paymentContractItem.payment_contract_item_type_id == 1"
						v-model="paymentContractItem.unit_price"
						:precision="2"
						:errorBorder="!paymentContractItemValidation.unit_price"
						:label="'* ' + $t('fields.unitPriceNeto')"
					></NumberField>
				</v-col>
				<v-col cols="12">
					<NumberField
						:disabled="paymentContractItem.unit_price == null"
						v-model="paymentContractItem.unit_discount_percentage"
						:precision="2"
						:errorBorder="!paymentContractItemValidation.unit_discount_percentage"
						:label="$t('fields.unitDiscount2')"
					></NumberField>
				</v-col>
				<v-col
					cols="12"
					style="display: flex; align-items: center"
					v-if="paymentContractItem.payment_contract_item_type_id == 1"
				>
					<CheckBox v-model="hasAdditionalAmount" :label="$t('fields.additionalAmount')"></CheckBox>
				</v-col>
				<v-col cols="12" v-if="hasAdditionalAmount">
					<NumberField
						v-model="additionalAmount"
						:precision="2"
						:label="$t('fields.additionalAmount')"
					></NumberField>
				</v-col>
				<v-col cols="12">
					<NumberField
						:disabled="true"
						v-model="paymentContractItem.unit_discount"
						:precision="2"
						:errorBorder="!paymentContractItemValidation.unit_discount"
						:label="$t('fields.unitDiscount')"
					></NumberField>
				</v-col>
				<v-col cols="12">
					<NumberField2
						:disabled="true"
						v-model="paymentContractItem.total"
						:precision="2"
						:label="$t('fields.amountNeto')"
					></NumberField2>
				</v-col>
				<v-col cols="12">
					<NumberField2
						:disabled="true"
						v-model="paymentContractItem.tax"
						:precision="2"
						:label="$t('fields.vat')"
					></NumberField2>
				</v-col>
				<v-col cols="12">
					<NumberField2
						:disabled="true"
						v-model="paymentContractItem.vat_total"
						:precision="2"
						:label="$t('fields.totalVat')"
					></NumberField2>
				</v-col>
				<v-col cols="12">
					<NumberField2
						:disabled="true"
						v-model="paymentContractItem.total_bruto"
						:precision="2"
						:label="$t('fields.amountBruto')"
					></NumberField2>
				</v-col>
			</v-row>
		</v-container>
		<v-spacer></v-spacer>
		<v-row>
			<v-col cols="12">
				<v-btn v-if="paymentContractStatus == 1" class="ma-2" color="primary" variant="text" @click="saveClick">
					{{ $t('buttons.save') }}
				</v-btn>
				<v-btn class="ma-2" color="basicButton" variant="text" @click="cancelClick">
					{{ $t('buttons.cancel') }}
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import Dropdown2 from '../../trinkets/Dropdown2';
import CheckBox from '../../trinkets/CheckBox';
import NumberField from '../../trinkets/NumberField';
import NumberField2 from '../../trinkets/NumberField2';
import PaymentContractItem from '../../../models/PaymentContractItem';

export default {
	name: 'PaymentContractItem',
	components: { NumberField, NumberField2, Dropdown2, CheckBox },
	props: {
		itemId: [String, Number],
		paymentContractStatus: [String, Number],
		vatExists: Boolean,
	},
	emits: ['close', 'reloadPaymentContractItems', 'addTempItem'],
	data() {
		return {
			paymentContractItem: new PaymentContractItem({ id: this.itemId, vat_exists: this.vatExists }),
			paymentContractItemValidation: new PaymentContractItem({}, true),
			testimonialPrice: null,
			testimonialAmount: null,
			additionalAmount: null,
			hasAdditionalAmount: false,
			originalUnitPrice: null,
		};
	},
	watch: {
		'itemId': function (newVal) {
			if (newVal) {
				this.getPaymentContractItem();
			}
		},
		'vatExists': function (newVal) {
			this.paymentContractItem.vat_exists = newVal;
		},
		'paymentContractItem.payment_contract_item_type_id': function (newVal) {
			if (newVal != 1) {
				this.hasAdditionalAmount = false;
			}
		},
		'paymentContractItem.unit_discount_percentage': function (newVal) {
			if (newVal != null) {
				this.updateUnitDiscount();
				this.updateTotal();
				this.updateVatTotal();
				this.updateTotalBruto();
			}
		},
		'paymentContractItem.quantity': function (newVal) {
			if (newVal != null) {
				this.updateUnitDiscount();
				this.updateTotal();
				this.updateVatTotal();
				this.updateTotalBruto();
			}
		},
		'paymentContractItem.unit_price': function (newVal) {
			if (newVal != null) {
				this.updateUnitDiscount();
				this.updateTotal();
				this.updateVatTotal();
				this.updateTotalBruto();
			}
		},
		'paymentContractItem.vat_exists': function (newVal) {
			if (!newVal) {
				this.paymentContractItem.tax = 0;
			} else {
				this.paymentContractItem.tax = 25;
			}
			this.updateTotal();
			this.updateVatTotal();
			this.updateTotalBruto();
		},
		'hasAdditionalAmount': function (newVal) {
			if (!newVal) {
				this.updateUnitDiscount();
				this.updateTotal();
				this.updateVatTotal();
				this.updateTotalBruto();
				this.additionalAmount = null;
			}
		},
		'additionalAmount': function () {
			this.updateUnitPrice();
		},
	},
	methods: {
		cancelClick() {
			this.paymentContractItem = new PaymentContractItem({ id: this.itemId, vat_exists: this.vatExists });
			this.$emit('close');
		},
		updateUnitPrice() {
			this.paymentContractItem.unit_price = this.originalUnitPrice + this.additionalAmount;
		},
		updateUnitDiscount() {
			this.paymentContractItem.unit_discount =
				(this.paymentContractItem.unit_discount_percentage / 100) * this.paymentContractItem.unit_price;
		},
		updateTotal(additional_amount = 0) {
			this.paymentContractItem.total = parseFloat(
				(
					(this.paymentContractItem.unit_price +
						additional_amount -
						(this.paymentContractItem.unit_discount_percentage / 100) *
							this.paymentContractItem.unit_price) *
					this.paymentContractItem.quantity
				).toFixed(2)
			);
		},
		updateVatTotal() {
			if (this.paymentContractItem.vat_exists) {
				this.paymentContractItem.vat_total = parseFloat(
					(
						(this.paymentContractItem.unit_price -
							(this.paymentContractItem.unit_discount_percentage / 100) *
								this.paymentContractItem.unit_price) *
						this.paymentContractItem.quantity *
						(this.paymentContractItem.tax / 100)
					).toFixed(2)
				);
			} else {
				this.paymentContractItem.vat_total = 0;
			}
		},
		updateTotalBruto(additional_amount = 0) {
			if (this.paymentContractItem.vat_exists) {
				this.paymentContractItem.total_bruto = parseFloat(
					(
						(this.paymentContractItem.unit_price +
							additional_amount -
							(this.paymentContractItem.unit_discount_percentage / 100) *
								this.paymentContractItem.unit_price) *
						this.paymentContractItem.quantity *
						(this.paymentContractItem.tax / 100 + 1)
					).toFixed(2)
				);
			} else {
				this.paymentContractItem.total_bruto = parseFloat(
					(
						(this.paymentContractItem.unit_price +
							additional_amount -
							(this.paymentContractItem.unit_discount_percentage / 100) *
								this.paymentContractItem.unit_price) *
						this.paymentContractItem.quantity
					).toFixed(2)
				);
			}
		},
		getItemTax(item) {
			var vm = this;
			this.$APICall(
				'get',
				'payment-contract-item-types/' + item.id,
				{},
				(data, success) => {
					if (success) {
						let usableData = JSON.parse(JSON.stringify(data));
						vm.paymentContractItem.item_type = usableData;
						vm.paymentContractItem.tax = usableData.tax_percentage;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		handleCourseSelected(item) {
			this.paymentContractItem.course.name = item.name;
			this.getCoursePrice(item.id);
		},
		getCoursePrice(course_id) {
			var vm = this;
			this.$APICall(
				'get',
				'courses/' + course_id,
				{},
				(data, success) => {
					if (success) {
						vm.paymentContractItem.unit_price = data.price_neto;
						vm.originalUnitPrice = data.price_neto;
						vm.testimonialAmount = data.testimonial_amount;
						vm.testimonialPrice = data.testimonial_price;
						if (vm.vatExists) {
							vm.paymentContractItem.vat_exists = data.vat_exists;
						}
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		getPaymentContractItem() {
			var vm = this;
			this.$APICall(
				'get',
				'payment-contract-item/' + this.itemId,
				{},
				(data, success) => {
					if (success) {
						let usableData = JSON.parse(JSON.stringify(data));
						vm.originalUnitPrice = data.unit_price;
						vm.paymentContractItem = new PaymentContractItem(usableData);
						vm.paymentContractItem.item_type = {};
						vm.paymentContractItem.payment_contract_item_type = {};
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		createTestimonial() {
			let testimonial = new PaymentContractItem({
				id: 0,
				payment_contract_item_type_id: 3,
				quantity: this.paymentContractItem.quantity * this.testimonialAmount,
				unit_price: this.testimonialPrice,
				total: this.paymentContractItem.quantity * this.testimonialAmount * this.testimonialPrice,
				total_bruto: this.paymentContractItem.quantity * this.testimonialAmount * this.testimonialPrice,
			});
			testimonial.payment_contract_item_type.name = 'Potvrdnica';
			return testimonial;
		},
		apiCall(action, addition, paymentContractItem) {
			let vm = this;
			this.$APICall(action, 'payment-contract-items' + addition, paymentContractItem, (data, success) => {
				if (success) {
					if (!paymentContractItem.payment_contract_item_type.hasOwnProperty('name')) {
						if (paymentContractItem.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
					}
					vm.$modalBus.$emit('reloadPaymentContractItems');
					vm.$modalBus.$emit('reloadPaymentContract');
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
				this.$emit('close');
			});
		},
		saveClick() {
			let success = true;
			let errorMessages = '';

			if (this.paymentContractItem.unit_price == null || this.paymentContractItem.unit_price === '') {
				if (this.paymentContractItem.payment_contract_item_type_id == 1) {
					errorMessages += this.$t('alerts.coursePriceUndefiend') + '<br />';
				}
				success = false;
				this.paymentContractItemValidation.unit_price = false;
			} else {
				this.paymentContractItemValidation.unit_price = true;
			}

			if (
				this.paymentContractItem.unit_discount_percentage != null &&
				(this.paymentContractItem.unit_discount_percentage > 100 ||
					this.paymentContractItem.unit_discount_percentage < 0)
			) {
				success = false;
				this.paymentContractItemValidation.unit_discount_percentage = false;
				errorMessages +=
					this.$t('alerts.valueError')
						.replace('%field%', this.$t('fields.unitDiscount2'))
						.replace('%min%', '0')
						.replace('%max%', 100) + '<br />';
			} else {
				this.paymentContractItemValidation.unit_discount_percentage = true;
			}

			if (!this.paymentContractItem.payment_contract_item_type_id) {
				success = false;
				this.paymentContractItemValidation.payment_contract_item_type_id = false;
			} else {
				if (this.paymentContractItem.payment_contract_item_type_id != 1) {
					this.paymentContractItem.course_id = null;
				} else {
					if (!this.paymentContractItem.course_id) {
						success = false;
						this.paymentContractItemValidation.course_id = false;
					} else {
						this.paymentContractItemValidation.course_id = true;
					}
				}
				this.paymentContractItemValidation.payment_contract_item_type_id = true;
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				if (this.$route.params.id == 0) {
					this.paymentContractItem.payment_contract_item_type.name = this.paymentContractItem.item_type.name;
					this.$emit('addTempItem', this.paymentContractItem);
					if (this.paymentContractItem.payment_contract_item_type_id == 1) {
						let testimonial = this.createTestimonial();
						this.$emit('addTempItem', testimonial);
					}
					this.paymentContractItem = new PaymentContractItem({ id: this.itemId, vat_exists: this.vatExists });
				} else {
					let vm = this;
					let action = 'post';
					let addition = '';
					if (this.paymentContractItem.id != 0) {
						action = 'put';
						addition = '/' + this.paymentContractItem.id;
					}

					this.paymentContractItem.payment_contract_id = this.$route.params.id;
					this.apiCall(action, addition, this.paymentContractItem);
					if (
						this.paymentContractItem.payment_contract_item_type_id == 1 &&
						this.paymentContractItem.id == 0
					) {
						let testimonial = this.createTestimonial();
						testimonial.payment_contract_id = this.$route.params.id;
						vm.apiCall(action, addition, testimonial);
					}
					this.paymentContractItem = new PaymentContractItem({ id: this.itemId, vat_exists: this.vatExists });
				}
			}
		},
	},
	mounted() {
		if (this.itemId !== 0) {
			this.getPaymentContractItem();
		}
	},
};
</script>

<style scoped>
.v-input--selection-controls {
	margin-top: 8px;
	margin-bottom: 8px;
}
</style>
